import React from "react"
import { WagtailBlockProps } from "../../services/api/types"
import { Col, Container, Row } from "../../styles/grid.styles"
import { LazyImage } from "../lazy-image"
import { BlockTitle } from "../base"
import * as S from "./ImageAndTextWithLinks.styled";

interface ImageAndTextWithLinkItem {
  image: string
  text: string
  link: {
    link_target: string
    external_link: string
    page_link: string
    document_link: string
    anchor_link: string
  }
}

export interface ImageAndTextWithLinksProps {
  heading: string
  items: ImageAndTextWithLinkItem[]
}

export interface ImageAndTextWithLinkAPIProps extends WagtailBlockProps {
  value: ImageAndTextWithLinksProps
}

const ImageAndTextWithLinkItemComponent = (item: ImageAndTextWithLinkItem) => {
  const linkUrl = item.link.external_link || item.link.page_link || item.link.document_link || '#'
  const linkTarget = item.link.link_target || '_self'

  return (
    <S.ImageAndTextWithLinkItem>
      <S.ImageWrap>
        <a
          href={linkUrl}
          target={linkTarget}
        >
          <LazyImage src={item.image} alt={item.text} />
        </a>
      </S.ImageWrap>
      <S.Text><a
        href={linkUrl}
        target={linkTarget}
      >{item.text}</a></S.Text>
    </S.ImageAndTextWithLinkItem>
  )
}

export const ImageAndTextWithLinks = (props: ImageAndTextWithLinksProps) => {
  const { heading, items } = props

  return (
    <S.ImageAndTextWithLinksWrap>
      <Container>
        <BlockTitle isYouFitness>{heading}</BlockTitle>
        <Row gutter={16}>
          {items.map((item, index) => (
            <Col key={index} xs={12} sm={6} md={4}>
              <ImageAndTextWithLinkItemComponent {...item} />
            </Col>
          ))}
        </Row>
      </Container>
    </S.ImageAndTextWithLinksWrap>
  )
}

ImageAndTextWithLinks.ApiBlockToProps = (data: ImageAndTextWithLinkAPIProps) => {
  if (data && data.value) {
    return data.value
  }
}
export default ImageAndTextWithLinks
